<template>
  <div class="charts-detail-wrap" id="map_detail_core_data">
    <h2>核心数据总览</h2>
    <!--维度切换-->
    <div class="date-wrap">
      <el-radio-group
        v-model="timeCycle"
        style="margin-top: 30px"
        @change="changeTimeCycle"
      >
        <el-radio-button label="1">日维度</el-radio-button>
        <el-radio-button label="2">周维度</el-radio-button>
        <el-radio-button label="3">月维度</el-radio-button>
      </el-radio-group>
    </div>
    <div class="charts-chooseDay">
      <!-- 自由选择日期 -->
      <div class="date-box">
        <div class="data-filter">
          <span class="mgr25">选择日期</span>
          <el-date-picker
            v-if="timeCycle == 1"
            :key="1"
            v-model="DateData"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="DatapickerOptions"
          >
          </el-date-picker>
          <DateWeekRange
            v-else-if="timeCycle == 2"
            v-model="DateDataWeek"
            range-separator="~"
            :pickerOptions="{
              firstDayOfWeek: 1,
              disabledDate: time => {
                return time.getTime() > Date.now();
              },
            }"
          ></DateWeekRange>
          <el-date-picker
            v-else
            v-model="DateDataMonth"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="~"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :pickerOptions="{
              disabledDate: time => {
                return time.getTime() > Date.now();
              },
              shortcuts: [
                {
                  text: '最近六个月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    end.setMonth(end.getMonth() - 1);
                    start.setMonth(start.getMonth() - 7);
                    picker.$emit('pick', [start, end]);
                  },
                },
                {
                  text: '最近一年',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    end.setMonth(end.getMonth() - 1);
                    start.setMonth(start.getMonth() - 13);
                    picker.$emit('pick', [start, end]);
                  },
                },
              ],
            }"
          >
          </el-date-picker>
          <el-button @click="getList" class="search_btn" type="info"
            >查找</el-button
          >
        </div>
        <!--固定周期切换-->
        <div class="date-wrap" v-if="timeCycle == 1">
          <el-radio-group
            v-model="userType"
            style="margin-bottom: 30px"
            @change="changeUserType"
          >
            <el-radio-button label="3">活跃玩家</el-radio-button>
            <el-radio-button label="1">新增玩家</el-radio-button>
            <el-radio-button label="2">回流玩家</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="download-wrap" @click="exportFn">
        <img src="@/assets/images/icon_export.png" />
        <span>导出数据</span>
      </div>
    </div>
    <el-table v-if="timeCycle == 1" id="selectTable" :data="list" border stripe>
      <el-table-column
        prop="dt"
        label="日期"
        sortable
        :sort-by="sortBy"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column label="活跃" align="center">
        <el-table-column
          align="center"
          sortable
          :sort-by="sortBy"
          prop="om_game_uin_cnt"
          label="游戏人数"
          width="120"
        ></el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="om_game_seconds_avg_user"
          label="人均时长"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.om_game_seconds_avg_user) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="om_game_seconds_avg_cnt"
          label="次均时长"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.om_game_seconds_avg_cnt) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="留存" align="center">
        <el-table-column
          prop="p2r"
          label="次留"
          align="center"
          sortable
          v-slot="scope"
        >
          <template>
            {{ filterNumber(scope.row.p2r) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="p3r"
          label="三留"
          align="center"
          sortable
          v-slot="scope"
        >
          <template>
            {{ filterNumber(scope.row.p3r) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="p7r"
          label="七留"
          align="center"
          sortable
          v-slot="scope"
        >
          <template>
            {{ filterNumber(scope.row.p7r) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="p30r"
          label="三十留"
          align="center"
          sortable
          v-slot="scope"
        >
          <template>
            {{ filterNumber(scope.row.p30r) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="内购收入" align="center">
        <el-table-column
          align="center"
          sortable
          prop="contribution"
          label="贡献点收入"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="minipoint"
          label="迷你点收入"
          width="150"
          sortable
        ></el-table-column>
      </el-table-column>
      <el-table-column label="迷你币/贡献点" align="center">
        <el-table-column
          sortable
          align="center"
          prop="coin_pay_num"
          label="迷你币付费数量（分成前）"
          width="220"
        ></el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="coin_pay_uin_cnt"
          label="迷你币付费人数"
          width="200"
        ></el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="contribution_arpu"
          label="贡献点ARPU"
          width="180"
        ></el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="contribution_arppu"
          label="贡献点ARPPU"
          width="180"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="contribution_pr"
          label="迷你币付费率"
          width="180"
          sortable
        ></el-table-column>
      </el-table-column>
      <el-table-column label="迷你点" align="center">
        <el-table-column
          align="center"
          sortable
          prop="point_pay_num"
          label="迷你点付费数量（分成前)"
          width="220"
        ></el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="point_pay_uin_cnt"
          label="迷你点付费人数"
          width="220"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="point_arpu"
          label="迷你点ARPU"
          width="200"
          sortable
        ></el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="point_arppu"
          label="迷你点ARPPU"
          width="200"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="point_pr"
          label="迷你点付费率"
          width="200"
          sortable
        ></el-table-column>
      </el-table-column>
      <el-table-column label="广告" align="center">
        <el-table-column
          align="center"
          prop="ad_cnt"
          label="广告播放次数"
          width="200"
          sortable
        ></el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="ad_uin_cnt"
          label="广告播放人数"
          width="200"
        ></el-table-column>
      </el-table-column>
      <el-table-column label="迷你豆" align="center">
        <el-table-column
          align="center"
          sortable
          prop="bean_pay_sum"
          label="迷你豆支付数量"
          width="220"
        ></el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="bean_pay_uin_cnt"
          label="迷你豆支付人数"
          width="220"
        ></el-table-column>
      </el-table-column>
    </el-table>
    <el-table
      v-else-if="timeCycle == 2"
      id="selectWeekTable"
      :data="weekList"
      border
      stripe
    >
      <el-table-column
        v-for="col in weekColumns"
        :prop="col.id"
        :key="col.id"
        :label="col.label"
        :width="col.width"
      >
        <template slot-scope="scope">
          <span v-if="col.id === 'r'">{{ filterNumber(scope.row.r) }}</span>
          <span v-else-if="col.id === 'game_seconds_avg_user'">{{
            toFixedNumber(scope.row[col.id])
          }}</span>
          <span v-else-if="col.id === 'coin_arppu'">{{
            toFixedNumber(scope.row[col.id])
          }}</span>
          <span v-else-if="col.id === 'coin_arpu'">{{
            toFixedNumber(scope.row[col.id])
          }}</span>
          <span v-else-if="col.id === 'ad_cnt_avg_user'">{{
            toFixedNumber(scope.row[col.id])
          }}</span>
          <span v-else-if="col.id === 'coin_pr'">{{
            filterNumber(scope.row[col.id])
          }}</span>
          <span v-else>{{ scope.row[col.id] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-else id="selectMonthTable" :data="monthList" border stripe>
      <el-table-column
        v-for="col in weekColumns.filter(item => item.id !== 'r')"
        :prop="col.id"
        :key="col.id"
        :label="col.label"
        :width="col.width"
      >
        <template slot-scope="scope">
          <span v-if="col.id === 'game_seconds_avg_user'">{{
            toFixedNumber(scope.row[col.id])
          }}</span>
          <span v-else-if="col.id === 'coin_arppu'">{{
            toFixedNumber(scope.row[col.id])
          }}</span>
          <span v-else-if="col.id === 'coin_arpu'">{{
            toFixedNumber(scope.row[col.id])
          }}</span>
          <span v-else-if="col.id === 'ad_cnt_avg_user'">{{
            toFixedNumber(scope.row[col.id])
          }}</span>
          <span v-else-if="col.id === 'coin_pr'">{{
            filterNumber(scope.row[col.id])
          }}</span>
          <span v-else>{{ scope.row[col.id] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  getMapDaysDetail,
  getMapWeeksDetail,
  getMapMonthsDetail,
} from '@/api/charts';
import { htmlToExcel, formatStartTime } from '@/utils/index';

const ONE_DAY = 24 * 60 * 60 * 1000;
const ONE_WEEK_TIME = ONE_DAY * 7;
const ONE_DAY_TIME = ONE_DAY - 1;
// 核心数据 月维度 默认选择前七个月
const default_month_end = new Date();
const default_month_start = new Date();
default_month_end.setMonth(default_month_end.getMonth() - 1);
default_month_start.setMonth(default_month_start.getMonth() - 7);
// 核心数据 周维度 默认选择前八周
const default_week_end = new Date();
const default_week_start = new Date();
const default_week_day = default_week_start.getDay();
default_week_end.setDate(
  default_week_end.getDate() + (default_week_day ? 7 - default_week_day : 0),
);
default_week_start.setDate(
  default_week_start.getDate() - (default_week_day ? default_week_day - 1 : 7),
);
default_week_start.setTime(
  default_week_start.getTime() - ONE_WEEK_TIME * 7 + ONE_DAY,
);
export default {
  data() {
    return {
      userType: 3,
      timeCycle: 1,
      DateData: [],
      DateDataWeek: [default_week_start, default_week_end],
      DateDataMonth: [default_month_start, default_month_end],
      mapId: 0,
      list: [],
      weekList: [],
      monthList: [],
      sortBy: [],
      orderBys: [],
      sortField: {},
      DatapickerOptions: {
        //判断
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcurts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近3个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      weekColumns: [
        {
          id: 'dt',
          label: '日期',
          width: 120,
        },
        {
          id: 'game_uin_cnt',
          label: '游戏人数',
          width: 120,
        },
        {
          id: 'all_game_cnt',
          label: '游戏次数',
          width: 120,
        },
        {
          id: 'game_seconds_sum',
          label: '游戏时长',
          width: 120,
        },
        {
          id: 'game_seconds_avg_user',
          label: '人均时长',
          width: 120,
        },
        {
          id: 'r',
          label: '次周留存率',
          width: 120,
        },
        {
          id: 'coin_pay_uin_cnt',
          label: '迷你币付费人数',
          width: 200,
        },
        {
          id: 'coin_pay_cnt',
          label: '迷你币付费次数',
          width: 200,
        },
        {
          id: 'coin_pay_sum',
          label: '迷你币付费金额',
          width: 200,
        },
        {
          id: 'coin_pr',
          label: '迷你币付费率',
          width: 200,
        },
        {
          id: 'coin_arppu',
          label: '迷你币arppu',
          width: 200,
        },
        {
          id: 'coin_arpu',
          label: '迷你币arpu',
          width: 200,
        },
        {
          id: 'ad_cnt',
          label: '广告播放次数',
          width: 200,
        },
        {
          id: 'ad_uin_cnt',
          label: '广告播放人数',
          width: 200,
        },
        {
          id: 'ad_cnt_avg_user',
          label: '人均广告次数',
          width: 200,
        },
      ],
      MonthColumns: [],
    };
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.DateData = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
    this.mapId = this.$route.query.id;
    // this.mapId = 10000000423010;
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      if (this.timeCycle == 1) {
        getMapDaysDetail({
          user_type: this.userType,
          map_id: this.mapId,
          stime: parseInt(this.DateData[0] / 1000, 10),
          etime: parseInt((this.DateData[1] + ONE_DAY_TIME) / 1000, 10),
        }).then(res => {
          if (res.code === 0) {
            this.list = res.data.list;
          }
        });
      } else if (this.timeCycle == 2) {
        getMapWeeksDetail({
          map_id: this.mapId,
          stime: formatStartTime(this.DateDataWeek[0]),
          etime: parseInt(this.DateDataWeek[1].getTime() / 1000, 10),
        }).then(res => {
          if (res.code === 0) {
            this.weekList = res.data.list;
          }
        });
      } else {
        getMapMonthsDetail({
          map_id: this.mapId,
          stime: formatStartTime(this.DateDataMonth[0]),
          etime: parseInt(
            (this.getNextMonthFirstDay(this.DateDataMonth[1]).getTime() - 1) /
              1000,
            10,
          ),
        }).then(res => {
          if (res.code === 0) {
            this.monthList = res.data.list;
          }
        });
      }
    },
    getNextMonthFirstDay(date) {
      date = new Date(date);
      date.setMonth(date.getMonth() + 1);
      date.setDate(1);
      return date;
    },
    changeUserType(value) {
      console.log('changeUserType', value);
    },
    changeTimeCycle(value) {
      console.log('changeTimeCycle', value);
    },
    exportFn() {
      if (this.timeCycle == 1) {
        htmlToExcel.getExcel(
          '#selectTable',
          `核心数据总览-日维度-${this.mapId}`,
        );
      } else if (this.timeCycle == 2) {
        htmlToExcel.getExcel(
          '#selectWeekTable',
          `核心数据总览-周维度-${this.mapId}`,
        );
      } else {
        htmlToExcel.getExcel(
          '#selectMonthTable',
          `核心数据总览-月维度-${this.mapId}`,
        );
      }
    },
    filterNumber(val) {
      if (!val) {
        return '';
      }
      const n = Number(val);
      return n ? `${(n * 100).toFixed(2)}%` : val;
    },
    toFixedNumber(val) {
      if (!val) {
        return '';
      }
      const n = Number(val);
      return n ? `${n.toFixed(2)}` : val;
    },
  },
};
</script>
<style lang="scss" scoped>
$--color-primary: #fd9b21;
.charts-detail-wrap {
  margin-top: 36px;
  h2 {
    font-size: 24px;
  }
  .charts-title {
    font-size: 20px;
    display: flex;
    justify-content: space-between;
  }
  .charts-chooseDay {
    margin: 20px 0;
    display: flex;
    .date-box {
      display: flex;
      flex: 1;
    }
    .data-filter {
      .mgr25 {
        margin-right: 25px;
      }
      .search_btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
        color: #595959;
        border-right: 1px solid #d9d9d9;
        border-top: 1px solid #d9d9d9;
        border-bottom: 1px solid #d9d9d9;
        background-color: #f4f4f5;
      }
    }
    .date-wrap {
      margin-left: 15px;
    }
    .choose-label {
      margin-right: 24px;
    }
    .download-wrap {
      cursor: pointer;
      color: #2b6ddf;
      font-size: 14px;
      padding-top: 10px;
      margin-right: 10px;
      img {
        margin-right: 8px;
      }
    }
  }
  .charts-detail {
    margin-bottom: 30px;
    .title {
      color: #8c8c8c;
      margin-bottom: 17px;
    }
    .btn-option {
      display: inline-block;
      width: auto;
      padding: 0 10px;
      height: 32px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      margin-right: 16px;
      cursor: pointer;
      line-height: 32px;
      text-align: center;
    }
    .active-chart-table {
      color: $--color-primary;
      background: #fffaed;
      border: 1px solid #ffc973;
      cursor: initial;
    }
  }

  .el-select.el-select--small {
    width: 84px;
    height: 36px;
  }
}
.img-no-data {
  text-align: center;
}

// ::v-deep .el-input__inner {
//   width: 84px;
//   height: 36px;
// }
.img-no-data {
  margin-top: 30px;
  text-align: center;
  background: url('../../../assets/images/img_bg_charts_no_data.png') no-repeat;
  height: 218px;
  img {
    margin-top: -30px;
    width: 160px;
    height: 160px;
  }
  p {
    font-size: 16px;
    color: #8c8c8c;
  }
}
::v-deep .el-table th > .cell {
  white-space: nowrap;
}
</style>
